const Heading = {
  baseStyle: {
    fontFamily: "inter",
  },
};

export default Heading;
